import { ChangeDetectionStrategy, Component, inject, OnInit, output, signal } from '@angular/core';
import {
  form,
  FormField,
  FormOptions,
  FormRoot,
  pattern,
  required,
  SchemaPathTree,
  TreeValidationResult,
} from '@angular/forms/signals';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { Country } from 'src/app/shared/model/country.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { SignalFormService } from 'src/app/shared/services/signal-form/signal-form.service';
import { NAME_INPUT } from 'src/app/shared/utils/utils';
import { DetailsStepFormModel } from './details-step.model';

@Component({
  selector: 'app-register-details-step',
  templateUrl: './details-step.component.html',
  styleUrls: ['./details-step.component.scss'],
  imports: [TranslatePipe, RouterLink, NgSelectComponent, FormField, FormRoot, FormFieldOnErrorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DetailsStepComponent implements OnInit {
  #api = inject(ApiService);

  public detailsSubmit = output<DetailsStepFormModel>();

  public countryList = signal<Country[]>([]);

  formModel = signal<DetailsStepFormModel>({ firstName: '', lastName: '', entityName: '', country: '' });
  formOptions: FormOptions<DetailsStepFormModel> = SignalFormService.formSubmitOptions(this.submitDetails.bind(this));
  form = form(this.formModel, this.#formValidation.bind(this), this.formOptions);

  ngOnInit(): void {
    this.#api.getCountries().then((countries) => this.countryList.set(countries));
  }

  public async submitDetails(): Promise<TreeValidationResult> {
    this.detailsSubmit.emit(this.formModel());
    return undefined;
  }

  #formValidation(path: SchemaPathTree<DetailsStepFormModel>): void {
    required(path.firstName);
    required(path.lastName);
    required(path.entityName);
    pattern(path.entityName, NAME_INPUT);
    required(path.country);
  }
}
